import React from 'react';
import {useTheme} from '../../theme';
import {Layout} from '../layout';
import {SpacerProps} from './types';

export const Spacer: React.FC<SpacerProps> = ({width, height}) => {
  const theme = useTheme();
  return (
    <Layout
      width={width ? theme.spacing[width] : undefined}
      height={height ? theme.spacing[height] : undefined}
    />
  );
};
